import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContainerPages = styled(Box)(({ padding }) => ({
  padding: `${padding}`,
}));

